import script from "./FieldTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldTextarea.vue?vue&type=script&setup=true&lang=js"

import "./FieldTextarea.vue?vue&type=style&index=0&id=16eced7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16eced7a"]])

export default __exports__